import { Component, OnInit, ViewChild } from '@angular/core';

import { saveAs as importedSaveAs } from "file-saver";
import * as moment from 'moment';

import { Book } from '../../models/Book';
import { Catalogazione } from '../../models/Catalogazione';
import { Dewey } from '../../models/Dewey';
import { Onix } from '../../models/Onix';
import { Contributor } from '../../models/Contributor';

import { UtilService } from './../../services/util.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css'],
  providers: [UtilService]
})
export class AdminComponent implements OnInit {
  wmodel: Book;

  constructor(private utils: UtilService) { }

   @ViewChild("fileInput") public fileInput;

  addFile(): void {
    let fi = this.fileInput.nativeElement;
    if (fi.files && fi.files[0]) {
      let fileToUpload = fi.files[0];
      this.utils.split(fileToUpload)
        .subscribe(
        data => {
          // console.log(result)


          let file = new Blob([data], { type: 'application/vnd.ms-excel' });
          importedSaveAs(file, 'nomi' + (moment().format('[-]YYYYMMDD[-]hhmmss')) + '.xlsx');

          // this.loading = false;
          // this.flashMessagesService.show('Uploaded successfully', {
          //   classes: ['alert', 'alert-success'],
          //   timeout: 1000,
          // });
        },
        error => {
          console.log(error)
          // this.loading = false;
          // if(error.statusCode==401) this.router.navigate(['']);
          // else
          //   this.flashMessagesService.show(error.message, {
          //     classes: ['alert', 'alert-danger'],
          //     timeout: 1000,
          //   });
        });
    }
  }


  removeChange(i) {
    console.log('removeChange index', i)
    this.wmodel.catalogazione.splice(i, 1);
  }

  addCatalogazione() {
    this.wmodel.catalogazione.push(new Catalogazione())
  }

  // ===== CONTRIBUTORS ======
  addContributor() {
    this.wmodel.contributor.push(new Contributor())
  }

  removeContributor(i) {
    console.log('removeContributor index', i)
    this.wmodel.contributor.splice(i, 1);
  }

  trackContributor(index: number, value: Contributor) {
    return index;
  }


  ngOnInit() {
    this.wmodel = new Book();
    // this.wmodel.testcat = new Catalogazione({
    //   codice: "D190400",
    //   label: "Dottrina sociale della Chiesa",
    //   parent: "D190000"
    // });

    this.wmodel.tipoProdotto = new Onix({
      value: 'BJ'
    })

    this.wmodel.catalogazione = [
      new Catalogazione({
        codice: "D190400",
        label: "Dottrina sociale della Chiesa",
        parent: "D190000"
      }),
      new Catalogazione({
        codice: "D010100",
        label: "Africa",
        parent: "D010000"
      }),
      new Catalogazione({
        codice: "D050100",
        label: "Catechesi",
        parent: "D050000"
      })
    ]
    // "catalogazione_dewey" : "361.37 (ed. 21) - SERVIZIO SOCIALE VOLONTARIO",
    // "catalogazione_dewey_liv01" : "300",
    // "catalogazione_dewey_liv02" : "100",
    // "catalogazione_dewey_liv03" : "060",
    // "catalogazione_dewey_liv04" : "000",
    this.wmodel.dewey_level1 = new Dewey({
      liv01: '300',
      liv02: '000',
      liv03: '000',
      liv04: '000'
    })
    this.wmodel.dewey_level2 = new Dewey({
      liv01: '300',
      liv02: '100',
      liv03: '000',
      liv04: '000'
    })
    this.wmodel.dewey_level3 = new Dewey({
      liv01: '300',
      liv02: '100',
      liv03: '060',
      liv04: '000'
    })
    this.wmodel.dewey_level4 = new Dewey({
      liv01: '300',
      liv02: '000',
      liv03: '000',
      liv04: '000'
    })
    this.wmodel.dewey_descrizione = 'xxxxxxxxxx'
  }

  trackByIndex(index: number, value: Catalogazione) {
    return index;
  }

  changeDeweyLevel01(e) {
    console.log('changeDeweyLevel01', e);
    this.ctrlDeweyDescrizione(e);
    this.wmodel.dewey_level2 = new Dewey({
      liv01: e.liv01
    })
    this.wmodel.dewey_level3 = new Dewey()
    this.wmodel.dewey_level4 = new Dewey()
  }
  changeDeweyLevel02(e) {
    console.log('changeDeweyLevel02', e);
    this.ctrlDeweyDescrizione(e);
    this.wmodel.dewey_level3 = new Dewey({
      liv01: e.liv01,
      liv02: e.liv02
    })
    this.wmodel.dewey_level4 = new Dewey()
  }
  changeDeweyLevel03(e) {
    console.log('changeDeweyLevel03', e);
    this.ctrlDeweyDescrizione(e);
    this.wmodel.dewey_level4 = new Dewey({
      liv01: e.liv01,
      liv02: e.liv02,
      liv03: e.liv03
    })
  }
  changeDeweyLevel04(e) {
    console.log('changeDeweyLevel04', e);
    this.ctrlDeweyDescrizione(e);
  }

  ctrlDeweyDescrizione(e: Dewey) {
    console.log('!!! ctrlDeweyDescrizione', e);
    this.wmodel.dewey_descrizione = e.deweyDescrittore ?
      e.deweyCodice + ' (ed.' + e.deweyEdizione + ') ' + e.deweyDescrittore : undefined;
  }

  getTitle(): string {
    return "admin";
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/admin.component.ts